
import { createDialogRoute } from '@gh/common-shared';

import { LeadBoardBusinessService } from '../../../../../resources/lead-board-business.service';
import { LostLeadReasonDialogComponent } from './lost-lead-reason-dialog.component';

export const createLostLeadReasonDialog = createDialogRoute({
  component: LostLeadReasonDialogComponent,
  init: LeadBoardBusinessService,
  config: {
    maxHeight: '100vh',
    width: '480px',
  },
});
